export class BrandModel {
    id: any
    slug: string = ''
    name: string = ''
    info: string = ''
    imageLgUrl: string = ''
    imageSmUrl: string = ''
    imageXsUrl: string = ''
    active: boolean = true
}